import styles from "./MyProfile.module.scss";
import { useMyProfile } from "./hooks/useMyProfile";
import { ProfileAvatar } from "./components/ProfileAvatar";
import { PersonalDataSection } from "./components/PersonalDataSection";
import { PasswordSection } from "./components/PasswordSection";
import { StripeConnectSection } from "./components/StripeConnectSection";
import { GoogleMeetSection } from "./components/GoogleMeetSection";
import { BusinessInfoSection } from "./components/BusinessInfoSection";
import { McpSection } from "./components/McpSection";
import { NotificationsSection } from "./components/NotificationsSection";
import { NewReservationNotificationsSection } from "./components/NewReservationNotificationsSection";
import { PlannyAccessSection } from "./components/PlannyAccessSection";

export const MyProfile = () => {
  const {
    profile,
    isLoading,
    isEditingPersonalData,
    setIsEditingPersonalData,
    invalidateProfile,
    isTenant,
    canManageMcp,
    isOpenedProfile,
    canManageNotifications,
    canUseDeviceNotifications,
    isStaff,
    canSeePlannyAccess,
    activeTab,
    setActiveTab,
  } = useMyProfile();

  return (
    <div className={styles.container}>
      <div className={styles.sheet}>
        <div className={styles.sheetHeader}>
          <h1 className={styles.pageTitle}>Моят профил</h1>
        </div>

        <div className={styles.avatarRow}>
          {isLoading ? (
            <div className={styles.avatarSkeleton} />
          ) : (
            profile && (
              <ProfileAvatar
                userId={profile.id}
                firstName={profile.firstName}
                lastName={profile.lastName}
                profilePhotoUrl={profile.profilePhotoUrl}
                onPhotoUploaded={invalidateProfile}
              />
            )
          )}
        </div>

        <div className={styles.tabs}>
          <button
            type="button"
            className={`${styles.tab} ${activeTab === "personal" ? styles.tabActive : ""}`}
            onClick={() => setActiveTab("personal")}
          >
            Лични данни
          </button>
          {isTenant && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "business" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("business")}
            >
              Фактуриране
            </button>
          )}
          <button
            type="button"
            className={`${styles.tab} ${activeTab === "password" ? styles.tabActive : ""}`}
            onClick={() => setActiveTab("password")}
          >
            Смяна на парола
          </button>
          {isTenant && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "stripe" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("stripe")}
            >
              Stripe
            </button>
          )}
          {isTenant && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "integrations" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("integrations")}
            >
              Интеграции
            </button>
          )}
          {canManageMcp && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "mcp" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("mcp")}
            >
              MCP
              <span className={styles.tabBadge}>Beta</span>
            </button>
          )}
          {canManageNotifications && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "notifications" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("notifications")}
            >
              Известия
            </button>
          )}
          {canSeePlannyAccess && (
            <button
              type="button"
              className={`${styles.tab} ${activeTab === "plannyAccess" ? styles.tabActive : ""}`}
              onClick={() => setActiveTab("plannyAccess")}
            >
              Достъп от Planny
            </button>
          )}
        </div>

        <div className={styles.tabContent}>
          {activeTab === "personal" && (
            <PersonalDataSection
              profile={profile}
              isEditing={isEditingPersonalData}
              onEditToggle={() => setIsEditingPersonalData((prev) => !prev)}
              onSaveSuccess={invalidateProfile}
            />
          )}
          {activeTab === "password" && <PasswordSection />}
          {activeTab === "stripe" && isTenant && <StripeConnectSection />}
          {activeTab === "integrations" && isTenant && (
            <GoogleMeetSection isOpenedProfile={isOpenedProfile} />
          )}
          {activeTab === "business" && isTenant && <BusinessInfoSection />}
          {activeTab === "mcp" && canManageMcp && <McpSection />}
          {activeTab === "notifications" && canManageNotifications && (
            <div className={styles.notificationsTab}>
              {canUseDeviceNotifications && <NotificationsSection />}
              {isStaff && <NewReservationNotificationsSection />}
            </div>
          )}
          {activeTab === "plannyAccess" && canSeePlannyAccess && <PlannyAccessSection />}
        </div>
      </div>
    </div>
  );
};
